import { render } from "./calendario_citas_ventas.vue?vue&type=template&id=b53875ac&lang=es"
import script from "./calendario_citas_ventas.vue?vue&type=script&lang=js"
export * from "./calendario_citas_ventas.vue?vue&type=script&lang=js"

import "./calendario_citas_ventas.vue?vue&type=style&index=0&id=b53875ac&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__